import { Common, ApiBind } from './common.model';

export class Publisher extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;
}
